import { useEffect } from 'react'
import './nameDialog.css'
import { GUID } from '../Services/ServiceTypes'
import { FolderNode, getNodeById } from '../WooNotes/folders'
import { WooNotesButton, WooNotesButtonSize, WooNotesButtonColor } from '../WooNotes/WooNotesButton'

type Props = {
  folderNodeId: GUID | undefined
  folderNodes: FolderNode[]
  folderHasItems: boolean
  onOK: () => void
  onCancel: () => void
}

export const getListOfLockedNodesForParentId = (nodes: FolderNode[], nodeId: string): string[] => {
  const result: string[] = []

  const findParentAndCollect = (currentNodes: FolderNode[]) => {
    for (const node of currentNodes) {
      if (node.id === nodeId) {
        collectLocked(node.children ?? [])
        return true
      }

      if (node.children && findParentAndCollect(node.children)) {
        return true
      }
    }
    return false
  }

  const collectLocked = (currentNodes: FolderNode[]) => {
    for (const node of currentNodes) {
      if (node.isLocked) {
        result.push(node.name)
      }

      if (node.children) {
        collectLocked(node.children)
      }
    }
  }

  findParentAndCollect(nodes)

  return result
}

export const ConfirmRemoveFolderDialog = ({ folderNodeId, folderNodes, folderHasItems, onOK, onCancel }: Props) => {
  useEffect(() => {
    if (!folderNodeId) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel()
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [folderNodeId, onCancel])

  if (!folderNodeId) return null

  const node = getNodeById(folderNodes, folderNodeId)
  if (!node) return null

  const lockedNodes = getListOfLockedNodesForParentId(folderNodes, folderNodeId)

  if (lockedNodes.length) {
    return (
      <div className="dialog-root">
        <div className="dialog-backdrop" onClick={onCancel} />

        <div className="dialog">
          <h3>Folder ({node?.name}) has at least one locked item, you are not allowed to remove the folder.</h3>

          <span style={{ fontWeight: 'bold' }}>Locked nodes...</span>
          <div className="dialog-content" style={{ display: 'flex', flexDirection: 'column' }}>
            {lockedNodes.map(lockedNode => (
              <span>{lockedNode}</span>
            ))}
          </div>

          <div className="actions">
            <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.White} onClick={() => onCancel()}>
              Okay, I understand!
            </WooNotesButton>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        {folderHasItems && (
          <h3>
            {node.children === undefined ? 'Item' : 'Folder'} ({node?.name}) has items, are you sure you want to delete it?
          </h3>
        )}
        {!folderHasItems && (
          <h3>
            Are you sure you want to delete {node.children === undefined ? 'item' : 'folder'} ({node?.name})?
          </h3>
        )}

        <div className="actions">
          <button onClick={onCancel}>Cancel</button>
          <button onClick={() => onOK()}>OK</button>
        </div>
      </div>
    </div>
  )
}
